import { useEffect, useMemo } from "react";
import {
  focusEditor,
  getStartPoint,
  Plate,
  usePlateSelectors,
} from "@udecode/plate-core";

import "../htmlContent/HtmlContent.css";

import type { EditorValue } from "./types";
import type { EditableProps } from "slate-react/dist/components/editable";

export interface TextEditorEditorProps {
  autoFocus?: boolean;
  id?: string;
  placeholder?: string;
  onBlur?: () => void;
  onFocus?: () => void;
}

export function TextEditorEditor({
  autoFocus,
  id,
  placeholder,
  onBlur,
  onFocus,
}: TextEditorEditorProps) {
  const selectors = usePlateSelectors(id);
  const editor = selectors.editor();
  const isRendered = selectors.isRendered();

  const editableProps: EditableProps = useMemo(
    () => ({
      "aria-label": placeholder,
      autoFocus,
      className: "HtmlContent",
      placeholder,
      onBlur,
      onFocus,
    }),
    [autoFocus, onBlur, onFocus, placeholder],
  );

  // HACK auto-focus
  // https://github.com/udecode/plate/issues/1587
  useEffect(() => {
    if (autoFocus && editor && isRendered) {
      requestAnimationFrame(() => {
        focusEditor(editor, getStartPoint(editor, [0]));
      });
    }
  }, [autoFocus, editor, isRendered]);

  return (
    <div className="TextEditorEditor">
      <Plate<EditorValue> editableProps={editableProps} id={id} />
    </div>
  );
}
